import { Component, inject, input, OnInit } from '@angular/core';
import { MatrixService } from '../../../services/matrix/matrix.service';
import { AppConfigService } from '../../../services/config/app-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-sso-callback',
  imports: [],
  templateUrl: './sso-callback.component.html'
})
/**
 * Begründung: Nur ein Callback für den Token
 */
export class SsoCallbackComponent implements OnInit {
  loginToken = input.required<string>();
  private readonly clientService = inject(MatrixService);
  private readonly config = inject(AppConfigService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    (async (): Promise<void> => {
      if (this.loginToken()) {
        await this.clientService.loginWithToken(this.loginToken(), this.config.get('homeserverHostname'));
        await this.router.navigate(['/keybackup']);
      } else {
        await this.router.navigate(['/login']);
      }
    })();
  }
}
